import { Temporal } from "temporal-polyfill";
import { feed, lookup_object } from "./api";
import { display_feed, display_lookup } from "./ui";

const start_date: HTMLInputElement | null = document.querySelector("#start-date");
const feed_form: HTMLFormElement | null = document.querySelector("#feed-form");
const end_date: HTMLInputElement | null = document.querySelector("#end-date");

const object_feed: HTMLDivElement | null = document.querySelector("#object-feed");

const lookup_form: HTMLFormElement | null = document.querySelector("#lookup-form");
const lookup_id: HTMLInputElement | null = document.querySelector("#lookup-id");
const lookup_data: HTMLDivElement | null = document.querySelector("#lookup-data");

const body_class = document.body.classList;

start_date?.addEventListener("change", () => {
  const date = Temporal.PlainDate.from(start_date.value);
  if (end_date) {
    end_date.min = date.toString();
    end_date.max = date.add({ days: 7 }).toString();
  }
});

feed_form?.addEventListener("submit", async (e) => {
  e.preventDefault();
  body_class.add("loading");
  if (start_date && end_date && object_feed) {
    const data = await feed(Temporal.PlainDate.from(start_date.value), Temporal.PlainDate.from(end_date.value));
    display_feed(object_feed, data, (id: number) => {
      if (lookup_form && lookup_id) {
        lookup_id.value = id.toString();
        lookup_form.requestSubmit();
      }
    });
  }
  body_class.remove("loading");
});

lookup_form?.addEventListener("submit", async (e) => {
  e.preventDefault();
  body_class.add("loading");
  if (lookup_id && lookup_data) {
    const data = await lookup_object(parseInt(lookup_id.value));
    console.log(data);
    display_lookup(lookup_data, data);
  }
  body_class.remove("loading");
});
